import { MAP_ENTITY_DRAWER_MOBILE_DRAWER_ID } from 'features/mapping/components/MapEntityDrawer/MapEntityDrawer.constants';
import { useWaitForElement } from 'hooks/useWaitForElement';
import { SEARCH_DRAWER_ID } from '../../constants';

export const useMobileDrawerElements = (
  enabled: boolean,
): {
  entityDrawerElement: Element | null;
  searchDrawerElement: Element | null;
} => {
  const entityDrawerElement = useWaitForElement(
    enabled ? `#${MAP_ENTITY_DRAWER_MOBILE_DRAWER_ID}` : null,
  );
  const searchDrawerElement = useWaitForElement(
    enabled ? `#${SEARCH_DRAWER_ID}` : null,
  );

  return { entityDrawerElement, searchDrawerElement };
};
